<template>

    <project-form
        :info-uri="infoUri"
        @reloadProjectData="$emit('reloadProjectData')"
    ></project-form>

</template>

<script>

import { mapGetters } from "vuex";
import ProjectForm from "../../../components/Projects/Form";

export default {

    components: {
        ProjectForm,
    },

    computed: {
        ...mapGetters([
            'getProject',
        ]),

        infoUri() {
            return this.route('api.v1.projects.info', {project_uuid:this.project.uuid});
        },

        project() {
            return this.getProject;
        },
    },

    metaInfo: {
        title:'Project wijzigen',
    },

    name:'ProjectFormEdit',

}

</script>
